import { render, staticRenderFns } from "./NewSubsSettingsModal.vue?vue&type=template&id=60fec40a&scoped=true&"
import script from "./NewSubsSettingsModal.vue?vue&type=script&lang=js&"
export * from "./NewSubsSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./NewSubsSettingsModal.vue?vue&type=style&index=0&id=60fec40a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fec40a",
  null
  
)

export default component.exports